import React from "react";
import { Tooltip } from "antd";
import { format, formatDistanceToNow } from "date-fns";
import { motion } from "framer-motion";
import { askAiTokens as t } from "./tokens";
import { AskAiMessage } from "./types";
import { fileIconFor, formatFileSize } from "./fileUtils";

interface Props {
  message: AskAiMessage;
}

const UserMessage: React.FC<Props> = ({ message }) => {
  const ts = message.ts;
  return (
    <motion.div
      initial={{ opacity: 0, y: 4 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.18, ease: "easeOut" }}
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-end",
        gap: t.space.s1,
        padding: `${t.space.s4}px 0`,
      }}
    >
      <div
        style={{
          fontSize: t.font.size.xs,
          color: t.color.textSubtle,
          display: "flex",
          gap: t.space.s2,
          alignItems: "center",
        }}
      >
        <span style={{ fontWeight: 500 }}>You</span>
        <Tooltip title={format(new Date(ts), "PPpp")}>
          <span>{formatDistanceToNow(new Date(ts), { addSuffix: true })}</span>
        </Tooltip>
      </div>
      <div
        style={{
          maxWidth: "78%",
          background:
            "linear-gradient(135deg, #eff4fb 0%, #e0eaf8 100%)",
          color: t.color.text,
          padding: `${t.space.s3}px ${t.space.s4}px`,
          borderRadius: 18,
          borderBottomRightRadius: 6,
          fontSize: t.font.size.message,
          lineHeight: 1.6,
          whiteSpace: "pre-wrap",
          wordBreak: "break-word",
          border: "1px solid rgba(37, 99, 235, 0.10)",
          boxShadow: "0 1px 2px rgba(15, 23, 42, 0.04)",
        }}
      >
        {message.text}
      </div>
      {message.attachments && message.attachments.length > 0 && (
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: t.space.s2,
            justifyContent: "flex-end",
            maxWidth: "70%",
          }}
        >
          {message.attachments.map((a, i) => (
            <div
              key={`${a.name}-${i}`}
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: t.space.s2,
                padding: `${t.space.s1}px ${t.space.s2}px`,
                background: t.color.surface,
                border: `1px solid ${t.color.border}`,
                borderRadius: t.radius.sm,
                fontSize: t.font.size.xs,
                color: t.color.textMuted,
              }}
            >
              <span>{fileIconFor(a.name)}</span>
              <span
                style={{
                  maxWidth: 160,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
                title={a.name}
              >
                {a.name}
              </span>
              <span style={{ color: t.color.textSubtle }}>
                {formatFileSize(a.size)}
              </span>
            </div>
          ))}
        </div>
      )}
    </motion.div>
  );
};

export default UserMessage;
